export default __webpack_public_path__ + "static/media/sticker-l.6239e36f.png";